import { EVENT_TABLE_COLUMNS } from '../config/event-table.config';
import type { DateTimeFilterBounds } from '@/shared/lib/dateTimeFilter';
import type { DataTableFilterMeta, DataTablePageEvent, DataTableSortEvent } from 'primereact/datatable';
import { DataTable } from '@/shared/ui/DataTable/DataTable';
import type { EventResponse } from '@/core/generated/api';
import React, { useState } from 'react';

interface EventsTableProps {
    onSort?: (event: DataTableSortEvent) => void;
    sortField?: string;
    sortOrder?: number;
    filters?: DataTableFilterMeta;
    onFilterChange?: (filters: DataTableFilterMeta) => void;
    events: EventResponse[];
    embedded: boolean;
    loading?: boolean;
    lazy?: boolean;
    totalRecords?: number;
    first?: number;
    rows?: number;
    onPageChange?: (event: DataTablePageEvent) => void;

    /** Применяет календарные границы серверной истории */
    onDateFilterChange?: (field: string, bounds: DateTimeFilterBounds | null) => void;
}

/** Отображает таблицу истории событий */
const EventsTable: React.FC<EventsTableProps> = (
    {
        events,
        embedded,
        loading = false,
        lazy = false,
        totalRecords,
        first: externalFirst,
        rows: externalRows,
        onPageChange,
        onDateFilterChange, filters, onFilterChange, onSort, sortField, sortOrder,
    }
) => {
    const [internalFirst, setInternalFirst] = useState(0);
    const [internalRowCount, setInternalRowCount] = useState(10);
    const first = externalFirst ?? internalFirst;
    const rowCount = externalRows ?? internalRowCount;



    /** Переключает страницу списка событий */
    const onPage = (event: DataTablePageEvent) => {
        if (onPageChange) {
            onPageChange(event);

            return;
        }
        setInternalFirst(event.first);
        setInternalRowCount(event.rows);
    };

    return (
        <DataTable
            embedded={embedded}
            onDateFilterChange={onDateFilterChange}
            paginator
            lazy={lazy}
            sortField={sortField ?? "created"}
            sortOrder={sortOrder ?? -1}
            onSort={onSort}
            removableSort
            stripedRows
            loading={loading}
            onPageChange={onPage}
            data={events}
            first={first}
            rows={rowCount}
            columns={EVENT_TABLE_COLUMNS}
            filters={filters}
            onFilterChange={onFilterChange}
            totalRecords={totalRecords ?? events.length}
            rowsPerPageOptions={[5, 10, 25, 50]}
            emptyMessage="События не найдены."
        />
    );
};

export default EventsTable;
